import { useGetCustomersQuery } from "../redux/Organization/Dashboard/DashboardSlice";
import {
  useGetGeneralAddressByMasterIdQuery,
  useLazyGetGeneralAddressByMasterIdQuery,
  useUpdateGeneralAddressMutation,
  useDeleteGeneralAddressMutation,
  useCreateGeneralAddressMutation,
} from "../redux/Organization/CreateNewCustomer/General.js";
import { useCreateOrganizationMutation, useUpdateOrganizationMutation, useLazyGetOrganizationByIdQuery, } from "../redux/Organization/CreateNewCustomer/NewCustomers.js";
import {
  useLazyGetMoreAddressByMasterIdQuery,
  useUpdateMoreAddressMutation,
  useDeleteMoreAddressMutation,
  useCreateMoreAddressMutation,
} from "../redux/Organization/CreateNewCustomer/MoreAddress.js";
import {
  useLazyGetCustomershipperQuery,
  useUpdateShipperMutation,
  useCreateShipperMutation,
} from "./Organization/CreateNewCustomer/Shiper/ShiperSlice";
import {
  useCreateBankdealerMutation,
  useUpdateBankdealerMutation,
  useLazyGetBankdealerbyIdQuery,
  useLazyGetBankdealerIdQuery,
  useDeleteBankdealerMutation,
} from "./Organization/CreateNewCustomer/CustomeDetails/BankDealer/Bankdealer";
import {
  useCreateKycAddressMutation,
  useLazyGetKycAddressQuery,
} from "./Organization/CreateNewCustomer/KYC/Address/KycSlice";
import {
  useCreateKycGeneralMutation,
  useLazyGetKycGeneralQuery,
} from "./Organization/CreateNewCustomer/KYC/General/kycGeneralSlice";
import {
  useCreateCustomerNotesMutation,
  useUpdateCustomerNotesMutation,
  useLazyGetNotesByCustomerIdQuery,
  useDeleteCustomerNoteMutation,
  useFileUploadMutation,
} from "./Organization/CreateNewCustomer/Notes/Notes";
import {
  useLazyGetServiceQuery,
  useCreateServiceMutation,
} from "./Organization/CreateNewCustomer/Service/Service";
import {
  useLazyGetContactAddressByMasterIdQuery,
  useUpdateContactAddressMutation,
  useDeleteContactAddressMutation,
  useCreateContactAddressMutation,
  useGetContactAddIdQuery
} from "../redux/Organization/CreateNewCustomer/Contact.js";
import {
  useLazyGetCustomerConsigneeQuery,
  useCreateConsigneeMutation,
  useUpdateConsigneeMutation, } from "../redux/Organization/CreateNewCustomer/Consignee.js";
  import { useLazyGetCarrierQuery,useCreateCarrierMutation } from "./Organization/CreateNewCustomer/Carrier/Carrier";
import {useLazyGetHistoryQuery} from "../redux/Organization/CreateNewCustomer/History/HistorySlice";
import { useCreateKycAuthorizedSignatoryMutation, useDeleteKycAuthorizedSignatoryMutation, useLazyGetKycAuthorizedSignatoryQuery } from "./Organization/CreateNewCustomer/KYC/AuthorizedSignatory/KycAuthorizedSlice";
import { useCreateAgentMutation, useLazyGetAgentQuery } from "./Organization/CreateNewCustomer/Agent/AgentSlice";
import {
  useCreateAEODetailsMutation,
  useLazyGetAEODetailsbyIdQuery,
} from "../redux/Organization/CreateNewCustomer/CustomeDetails/BankDealer/AeoSlice.js";
import { useParams } from "react-router";
import { useUser } from "@/Context/UserContext.jsx";
import {  useLazyGetKycDocumentQuery,
  useCreateKycDocumentMutation} from "../redux/Organization/CreateNewCustomer/KYC/KycDocument.js";
  import {  useGetRegByMasterIdQuery,
    useLazyGetRegByMasterIdQuery,
    useUpdateRegMutation,
    useDeleteRegMutation,
    useCreateRegMutation,} from "../redux/Organization/CreateNewCustomer/Reg.js"
import { useCreateDrawBackMutation, useUpdateDrawBackMutation, useDeleteDrawBackMutation } from "./Organization/CreateNewCustomer/CustomeDetails/DrawBackDetails/Drawbackdetails";
import {useApplyorganizationFilterMutation} from "../redux/Organization/Dashboard/DashboardfilterSlice"
import { useCreateCustomMasterMutation, useLazyGetCustomMasterQuery } from "./Organization/CreateNewCustomer/CustomeDetails/CustomMaster/CustomDetails";
export const OrganizationHookMap = {
  GeneralAddress: (id, subId) => {
    const [create, createState] = useCreateGeneralAddressMutation();
    const [update, updateState] = useUpdateGeneralAddressMutation();
    const [deleteFn, deleteState] = useDeleteGeneralAddressMutation();
    const [fetchGeneralAddress, { data, isLoading }] =
      useLazyGetGeneralAddressByMasterIdQuery();
    const fetch = async ({ id,subId }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchGeneralAddress({ id,subId }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
      deleteFn,
      deleteState,
    };
  },

  MoreAddress: (id) => {
    const [create, createState] = useCreateMoreAddressMutation();
    const [update, updateState] = useUpdateMoreAddressMutation();
    const [deleteFn, deleteState] = useDeleteMoreAddressMutation();
    const [fetchMoreAddress, { data, isLoading }] =
      useLazyGetMoreAddressByMasterIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
      deleteFn,
      deleteState,
    };
  },
  Contact: (id) => {
    const [create, createState] = useCreateContactAddressMutation();
    const [update, updateState] = useUpdateContactAddressMutation();
    const [deleteFn, deleteState] = useDeleteContactAddressMutation();
    const [fetchMoreAddress, { data, isLoading }] =
      useLazyGetContactAddressByMasterIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
      deleteFn,
      deleteState,
    };
  },

  customerFilter: (id) => {
    const [create, createState] = useCreateOrganizationMutation();
    const [update, updateState] = useUpdateOrganizationMutation();
    const [fetchNewCustomer, { data, isLoading }] =
      useLazyGetOrganizationByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchNewCustomer({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },
  //
  shiper: (id) => {
    //createCustomerMainShipment
    const [create, createState] = useCreateShipperMutation();
    const [update, updateState] = useUpdateShipperMutation();
    const [fetchShipper, { data, isLoading }] =
      useLazyGetCustomershipperQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchShipper({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },
  //
  consignee: (id) => {
    const [create, createState] = useCreateConsigneeMutation();
    const [update, updateState] = useUpdateConsigneeMutation();
    const [fetchShipper, { data, isLoading }] =
      useLazyGetCustomerConsigneeQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchShipper({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },

  bankdealer: (id) => {
    const [create, createState] = useCreateBankdealerMutation();
    const [update, updateState] = useUpdateBankdealerMutation();
    const [deleteFn, deleteState] = useDeleteBankdealerMutation();
    const [fetchMoreAddress, { data, isLoading }] =
      useLazyGetBankdealerbyIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
      deleteFn,
      deleteState,
    };
  },
  KycAddress: (id) => {
    const [create, createState] = useCreateKycAddressMutation();
    const [fetchMoreAddress, { data, isLoading }] = useLazyGetKycAddressQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },
  KycGeneral: (id) => {
    const [create, createState] = useCreateKycGeneralMutation();
    const [fetchMoreAddress, { data, isLoading }] = useLazyGetKycGeneralQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },
    KycAuthorizedSignatory: (id) => {
    const [create, createState] = useCreateKycAuthorizedSignatoryMutation();
    const [fetchSignatory, { data, isLoading }] = useLazyGetKycAuthorizedSignatoryQuery();
    const[deleteFn,setDeleteFn] = useDeleteKycAuthorizedSignatoryMutation()
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch Cusotmer data");
      return await fetchSignatory({ id }).unwrap();
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      deleteFn,setDeleteFn
    };
  },
  service: (id) => {
    const [create, createState] = useCreateServiceMutation();
    const [fetchMoreAddress, { data, isLoading }] = useLazyGetServiceQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },
  
  CustomerReg: (id) => {
    const [create, createState] = useCreateRegMutation();
    const [update, updateState] = useUpdateRegMutation();
    const [deleteFn, deleteState] = useDeleteRegMutation();
    const [fecthNotesDetails, { data, isLoading }] =
    useLazyGetRegByMasterIdQuery(id);
    const [fileUpload, fileUploadState] = useFileUploadMutation();
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = subId
        ? await fecthNotesDetails({ id, subId }).unwrap()
        : await fecthNotesDetails({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      update,
      updateState,
      data,
      isLoading,
      fetch,
      deleteFn,
      deleteState,
      fileUpload,
      fileUploadState,
    };
  },

  customerNotes: (id) => {
    const [create, createState] = useCreateCustomerNotesMutation();
    const [update, updateState] = useUpdateCustomerNotesMutation();
    const [fecthNotesDetails, { data, isLoading }] =
      useLazyGetNotesByCustomerIdQuery(id);
    const [fileUpload, fileUploadState] = useFileUploadMutation();
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = subId
        ? await fecthNotesDetails({ id, subId }).unwrap()
        : await fecthNotesDetails({ id }).unwrap();
      return response;
    };
    const [deleteFn, deleteState] = useDeleteCustomerNoteMutation();
    return {
      create,
      createState,
      update,
      updateState,
      data,
      isLoading,
      fetch,
      deleteFn,
      deleteState,
      fileUpload,
      fileUploadState,
    };
  },

  carrier: (id) => {
    const [create, createState] = useCreateCarrierMutation();
    const [fetchMoreAddress, { data, isLoading }] = useLazyGetCarrierQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchMoreAddress({ id }).unwrap();
    };
      return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },
    agentApi: (id) => {
    const [create, createState] = useCreateAgentMutation();
    const [fetchAgentData, { data, isLoading }] = useLazyGetAgentQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchAgentData({ id }).unwrap();
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },


  Organizationhistory: (id) => {
    const [fetchHistoryDetails, { data, isLoading }] = useLazyGetHistoryQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchHistoryDetails({ id }).unwrap();
      return response;
    };
    return { data, isLoading, fetch };
  },

  KYCDocuments: (id) => {
    const [create, createState] = useCreateKycDocumentMutation();
    const [fetchHistoryDetails, { data, isLoading }] =useLazyGetKycDocumentQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchHistoryDetails({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      data,
      isLoading,
      fetch,
    };
  },

  AeoDetails: (id) => {
    const [create, createState] = useCreateAEODetailsMutation();
    const [fetchHistoryDetails, { data, isLoading }] = useLazyGetAEODetailsbyIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchHistoryDetails({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetch,
    };
  },


  Drawbackdetails: (id) => {
    const [create, createState] = useCreateDrawBackMutation();
    const [update, updateState] = useUpdateDrawBackMutation();
    const [deleteFn, deleteState] = useDeleteDrawBackMutation();
    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },
  CustomDetails : (id) => {
    const[create, createState] = useCreateCustomMasterMutation();
    const[fetchCustomDetails,{data,isLoading}] = useLazyGetCustomMasterQuery();
    const fetchExtraApi = async ({id}) => {
      if(!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchCustomDetails({id}).unwrap();
      return response;
    }
    return{
      create,
      createState,
      data,
      isLoading,
      fetchExtraApi
    }
  },
  applyorganizationFilter:useApplyorganizationFilterMutation,
  getCustomers: useGetCustomersQuery,
  getShipperQuery: () => {
      const { formData } = useUser();
  
    // Correct extraction of customerAddressId from array
    const addressId = formData?.GeneralAddress?.[0]?.customerAddressId;
  
    const id = addressId ;
  
    console.log("📌 GeneralAddress[0] ID:", addressId);
  
    if (!id) {
      console.log("❌ No valid ID for Shipper API");
      return { data: [], isLoading: false, error: null };
    }
  
    const { data, isLoading, error } = useGetContactAddIdQuery({ id });
    return { data, isLoading, error };
  },
  
  
  
};




